export default __webpack_public_path__ + "static/media/05.b198abf6.webp";